import React, { FC } from 'react';
import { NetworkReference } from 'types/location';
import styled from 'styled-components';
import { ShareReview } from 'styles/Form/ShareReview';
import { useTranslation } from 'react-i18next';

type StyledProps = {
  color: string;
  backgroundColor: string;
};

const NetworkButton = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  height: 50px;
  margin-bottom: 15px;
  font-size: 16px;
  border-radius: 16px;
  background-color: ${props => props.backgroundColor};
  color: ${props => props.color};
`;

export const ShareBlock: FC<{
  networks: NetworkReference[];
}> = ({ networks }) => {
  const { t } = useTranslation();
  return (
    <>
      <ShareReview>{t('shareReview')}</ShareReview>
      {networks.map(network => (
        <NetworkButton
          backgroundColor={network.button_color}
          color={network.color}
          onClick={() => open(network.link, '_self')}
        >
          {network.title}
        </NetworkButton>
      ))}
    </>
  );
};
